import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OutgoingTermScheduleComponent } from './outgoing-term-schedule/outgoing-term-schedule.component';
import { IncomingTermScheduleComponent } from './incoming-term-schedule/incoming-term-schedule.component';
import {FormsModule} from '@angular/forms';
import {DataTablesModule} from 'angular-datatables';
import {TooltipModule} from 'primeng/primeng';
import { IncomingTermVisaSettingsComponent } from './incoming-term-visa-settings/incoming-term-visa-settings.component';

@NgModule({
  declarations: [OutgoingTermScheduleComponent, IncomingTermScheduleComponent, IncomingTermVisaSettingsComponent],
    imports: [CommonModule, FormsModule, DataTablesModule, TooltipModule]
})
export class TermScheduleModule { }
